"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageBanner = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Link_1 = require("../../atoms/Link/Link");
const PageBannerAction = ({ link }) => {
    const className = `font-bold ${link.tracking}`;
    return !link.anchor ? (react_1.default.createElement(Link_1.Link, { className: className, size: "base", to: link.to }, link.text)) : (react_1.default.createElement(Link_1.Anchor, { className: className, size: "base", href: link.to, target: link.target }, link.text));
};
const bannerStyle = (type) => {
    switch (type) {
        case 'alert':
            return 'bg-yellow-2';
        default:
            return 'bg-blue-1';
    }
};
const PageBanner = ({ link, type, text, src, testing }) => {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('w-full', bannerStyle(type)), "data-testid": testing && 'page-banner-wrapper' },
        react_1.default.createElement("div", { className: "container m-auto flex py-5 px-4 lg:items-center lg:py-7" },
            src && react_1.default.createElement("img", { src: src, alt: "", className: "mr-2 h-6" }),
            react_1.default.createElement("div", { className: "flex flex-grow flex-col justify-between lg:flex-row lg:items-center" },
                react_1.default.createElement("div", { className: "font-display text-xl font-bold" }, text),
                link && (react_1.default.createElement("div", { className: "flex items-center divide-x-2 divide-grey-2" }, Array.isArray(link) ? (link.map((linkItem) => react_1.default.createElement(PageBannerAction, { key: linkItem.to, link: linkItem }))) : (react_1.default.createElement(PageBannerAction, { link: link }))))))));
};
exports.PageBanner = PageBanner;
